(function () {
  var MOBILE_MQ = '(max-width: 749px)';

  function initTgSlider(wrapper) {
    var track = wrapper.querySelector('.tg-product-slider__track');
    if (!track || track.dataset.tgInit === '1') return;
    track.dataset.tgInit = '1';

    var slides = track.querySelectorAll('.tg-product-card');
    var totalSlides = slides.length;
    var currentIndex = 0;

    var prevBtn = wrapper.querySelector('.tg-product-slider__nav--prev');
    var nextBtn = wrapper.querySelector('.tg-product-slider__nav--next');

    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function getVisibleCount() {
      return isMobile()
        ? parseInt(track.getAttribute('data-visible-mobile')) || 2
        : parseInt(track.getAttribute('data-visible-desktop')) || 4;
    }

    function applyEdges() {
      if (isMobile()) {
        slides.forEach(function (slide) {
          slide.classList.remove('tg-product-card--edge-left', 'tg-product-card--edge-right');
        });
        return;
      }
      var visible = getVisibleCount();
      var rightIndex = currentIndex + visible - 1;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('tg-product-card--edge-left', i === currentIndex);
        slide.classList.toggle('tg-product-card--edge-right', i === rightIndex);
      });
    }

    function update() {
      if (isMobile()) {
        track.style.transform = '';
        if (prevBtn) prevBtn.removeAttribute('disabled');
        if (nextBtn) nextBtn.removeAttribute('disabled');
        applyEdges();
        return;
      }
      var visible = getVisibleCount();
      var slideWidth = 100 / visible;
      var maxIndex = Math.max(0, totalSlides - visible);
      if (currentIndex > maxIndex) currentIndex = maxIndex;
      if (currentIndex < 0) currentIndex = 0;
      track.style.transform = 'translateX(-' + (currentIndex * slideWidth) + '%)';
      if (prevBtn) {
        if (currentIndex <= 0) prevBtn.setAttribute('disabled', 'disabled');
        else prevBtn.removeAttribute('disabled');
      }
      if (nextBtn) {
        if (currentIndex >= maxIndex) nextBtn.setAttribute('disabled', 'disabled');
        else nextBtn.removeAttribute('disabled');
      }
    }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'transform') applyEdges();
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (isMobile()) return;
        currentIndex = Math.max(0, currentIndex - 1);
        update();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (isMobile()) return;
        var visible = getVisibleCount();
        var maxIndex = Math.max(0, totalSlides - visible);
        currentIndex = Math.min(maxIndex, currentIndex + 1);
        update();
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        update();
        applyEdges();
      }, 200);
    });

    wrapper._tgUpdate = update;

    update();
    applyEdges();
  }

  function initTabs(root) {
    if (!root || root.dataset.tgTabsInit === '1') return;
    root.dataset.tgTabsInit = '1';

    var buttons = root.querySelectorAll('[data-tg-tab-btn]');
    var panels = root.querySelectorAll('[data-tg-tab-panel]');

    function activate(idx) {
      buttons.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
      panels.forEach(function (p, i) { p.classList.toggle('is-active', i === idx); });
      var active = panels[idx];
      if (active) {
        active.querySelectorAll('.tg-product-slider').forEach(function (slider) {
          if (!slider.querySelector('.tg-product-slider__track[data-tg-init="1"]')) {
            initTgSlider(slider);
          } else if (slider._tgUpdate) {
            slider._tgUpdate();
          }
        });
      }
    }

    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () { activate(i); });
    });

    panels.forEach(function (panel) {
      if (panel.classList.contains('is-active')) {
        panel.querySelectorAll('.tg-product-slider').forEach(initTgSlider);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tg-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-tg-tabs]');
    if (root) initTabs(root);
  });
})();
